import { Button } from "@studyplus/boron-ui";
import { useEffect, useState } from "react";
import { Modal } from "../../../../../components/atoms/Modal";
import { SearchInput } from "../../../../../components/general/SearchInput";
import { Tag } from "../DownloadForm";
import { TagSelectionDisplay } from "./TagSelectionDisplay";
import { useTagFiltering } from "./useTagFiltering";

type Props = {
  sectionId: string;
  tags: Tag[];
  selectedTags: Tag[];
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (selectedTags: Tag[]) => void;
};

export const StudentPasscodeInactivationTagModal = (props: Props) => {
  const { tags, selectedTags, isOpen, onClose, onSubmit } = props;
  const [selectedTagIds, setSelectedTagIds] = useState<string[]>([]);
  const { searchTerm, setSearchTerm, groupedTags } = useTagFiltering(tags);
  const EXCLUDED_STATUS_NAMES = ["招待前", "停止中"];

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    setSelectedTagIds(filterExcludedTags(selectedTags).map((tag) => tag.id));
  }, [isOpen, selectedTags]);

  const filterExcludedTags = (tags: Tag[]): Tag[] => {
    return tags.filter(
      (tag) =>
        !(tag.type === "status" && EXCLUDED_STATUS_NAMES.includes(tag.name)),
    );
  };

  const toggleTagSelection = (tagId: string) => {
    setSelectedTagIds((prev) =>
      prev.includes(tagId)
        ? prev.filter((id) => id !== tagId)
        : [...prev, tagId],
    );
  };

  const submitSelectedTags = () => {
    const selectedTagObjects = tags.filter((tag) =>
      selectedTagIds.includes(tag.id),
    );
    onSubmit(selectedTagObjects);
    onClose();
  };

  const removeTagFromSelection = (tagId: string) => {
    setSelectedTagIds((prev) => prev.filter((id) => id !== tagId));
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="max-w-[60rem] w-[90%] mx-auto my-20 rounded-lg overflow-hidden"
    >
      <Modal.Header onClose={onClose}>生徒タグの選択</Modal.Header>
      <Modal.Body>
        <div className="mb-8">
          <SearchInput
            type="text"
            placeholder="タグを検索"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onReset={() => setSearchTerm("")}
            isBlock
          />
        </div>
        <TagSelectionDisplay
          selectedTagIds={selectedTagIds}
          tags={tags}
          groupedTags={groupedTags}
          onRemoveTag={removeTagFromSelection}
          onTagToggle={toggleTagSelection}
        />
        <div className="flex justify-center mt-8">
          <Button
            type="button"
            onClick={submitSelectedTags}
            className="w-[9.2rem]"
          >
            決定
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
